import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSparepartExpenses } from '../../../actions/sparepart_expense';
import SparepartExpenseItem from '../expenses/SparepartExpenseItem';
import TableSpinner from '../../layout/TableSpinner';
import CustomPaginationWithManyPages from '../../layout/CustomPaginationWithManyPages';

const SparePartExpenses = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    
    // Extract ID from URL path manually
    const id = location.pathname.match(/\/spare-parts\/(\d+)/)?.[1];
    
    const { sparepart_expense } = useSelector(state => state);
    const { 
        expenses, 
        loading, 
        numberOfPages, 
        currentPage 
    } = sparepart_expense;

    useEffect(() => {
        // Filter expenses by spare part ID
        const filters = { spare_part_id: id };
        dispatch(getSparepartExpenses(1, filters));
    }, [dispatch, id]);

    if (loading) {
        return <TableSpinner />;
    }

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0">Ehtiyot qismi chiqimlari</h5>
                </div>
                <div className="card-body p-0">
                    {expenses && expenses.length > 0 ? (
                        <>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Ehtiyot qismi</th>
                                            <th scope="col">Miqdor</th>
                                            <th scope="col">Sklad</th>
                                            <th scope="col">Iste'molchi</th>
                                            <th scope="col">Sana</th>
                                            <th scope="col">Amallar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenses.map((expense, index) => (
                                            <SparepartExpenseItem
                                                key={expense.id}
                                                expense={expense}
                                                number={(currentPage - 1) * 10 + index + 1}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            {numberOfPages > 1 && (
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <CustomPaginationWithManyPages
                                        numberOfPages={numberOfPages}
                                        current_page={currentPage}
                                        getPageItems={getSparepartExpenses}
                                        custom_params={{ spare_part_id: id }}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Bu ehtiyot qismi uchun hech qanday chiqim topilmadi.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SparePartExpenses; 